module.exports = __webpack_public_path__ + "img/tiktok.65df9e9a.png";